<template>
  <div class="totalResult">
    <h2 class="h3">{{ indexType }}</h2>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "ResultsReturned",
  props: {
    totalResults: {
      type: Number,
      required: true,
      default: 0
    },
    indexType: {
      type: String,
      required: true,
      default: ""
    }
  }
});
</script>
